import React from "react";
import {Tooltip} from "@mui/material";

export const PopupWrapper = (props) => {
    const {popupText, className, style, children} = props;

    return (
        <Tooltip
            arrow
            placement="bottom"
            title={popupText}
        >
            <div className={className} style={style}>
                {children}
            </div>
        </Tooltip>
    )
}